// tslint:disable
import { Component } from '@angular/core';

@Component({
    selector: 'cmdivider',
    templateUrl: 'cmdivider.component.html'
})
export class CMDividerComponent {}